'use client';

import { useEffect, useState } from 'react';

import { formatPostDate } from '../../../functions/format-post-date';

interface Props {
  /** Publish time as epoch millis. */
  publishedAt: number;
}

/**
 * Client island for a post's footer timestamp. The label ("2 hours ago" /
 * "Jan 12, 3:24 PM") is clock-relative, and the bio document is statically
 * cached — neither the server render nor the SSR pass may read the clock, so
 * the label resolves in an effect right after hydration (the baked HTML shows
 * an empty slot for one frame).
 */
export function PostTimestamp({ publishedAt }: Props) {
  const [label, setLabel] = useState('');

  useEffect(() => {
    const publishedDate = new Date(publishedAt);
    setLabel(formatPostDate(publishedDate));
  }, [publishedAt]);

  if (!label) {
    return null;
  }
  return <span className="text-[11px] opacity-85">{label}</span>;
}
